// src/components/Footer.js
import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();
  return (
    <Box
      sx={{
        padding: 2,
        backgroundColor: theme.palette.primary.main,
        color: "white",
        textAlign: "center",
      }}
    >
      <Typography variant="body2">
        © {currentYear} Vyoobam Tech. All rights reserved. | Empowering Digital Solutions
      </Typography>
    </Box>
  );
};

export default Footer;
